import {
  BadRequestError,
  ConflictRequestError,
  GenericRequestError,
  NotFoundRequestError,
  UnauthorizedRequestError
} from 'models/errors'

export function getRequestError(
  status: number,
  statusText: string,
  info = '',
  field = null,
  isRedirectToValidAP = false
) {
  if (status === 409) {
    return new ConflictRequestError(info)
  }
  if (status === 404) {
    return new NotFoundRequestError(statusText)
  }
  if (status === 401) {
    return new UnauthorizedRequestError(statusText, isRedirectToValidAP)
  }
  if (status === 400) {
    return new BadRequestError(info, field)
  }
  return new GenericRequestError(statusText)
}

export function getErrorDisplayInfo(error: Error) {
  if (error instanceof UnauthorizedRequestError && error.isRedirectToValidAP) {
    return {
      title: 'Redirigint',
      message: 'Redirigint al servei...'
    }
  }
  if (error instanceof UnauthorizedRequestError) {
    return {
      message:
        "El vostre usuari no ha estat autoritzat per accedir a aquest servei. Si creieu que hauríeu de tenir-hi accés, poseu-vos en contacte amb la persona del vostre ens (el gestor) encarregada de gestionar els usuaris d'EACAT. En cas de conèixer al vostre gestor, contacteu amb ell ",
      linkMessage: "Centre d'Atenció a l'Usuari - CAU",
      linkUrl: 'https://suport.aoc.cat/'
    }
  }
  if (error instanceof NotFoundRequestError) {
    return {
      title: 'Recurs no trobat',
      message: 'El recurs al que intenteu accedir no existeix',
      hasTorna: true
    }
  } else {
    return {
      title: "La vostra petició no s'ha pogut tractar",
      message:
        'Si us plau, torneu a intentar-ho en uns instants. Si el problema persisteix poseu-vos en contacte amb el ',
      linkMessage: "Servei d'Atenció a l'Usuari",
      linkUrl: 'https://suport.aoc.cat/',
      hasTorna: true
    }
  }
}
